import { Items } from 'src/app/core/models/common/items.model';

export const CONSTS = {
  SELECT_DATE: $localize`Select Date`,
  SORT_CODE: $localize`Sort Code`,
  SELECT: $localize`Select`,
  TRACKING_NUMBER: $localize`Tracking Number`,
  ENTER_TRACKING_NUMBER: $localize`Enter or upload Tracking Numbers`,
  TRACKING_NUMBER_INVALID_ERROR: $localize`Please enter a valid Tracking Number`,
  TRACKING_NUMBER_EXIST_IN_TABLE_ERROR: $localize`Tracking Number already exists in the table`,
  ENTER_MULTIPLE_TRACKING_NUMBER: $localize`Enter Tracking Numbers`,
  FILE_UPLOAD: $localize`File Upload`,
  SUBMIT: $localize`Submit`,
  SORT_DATE: $localize`Sort Date`,
  LOCATION: $localize`Location`,
  LOCATION_PLACEHOLDER: $localize`Enter Location`,
  LOCATION_INVALID_ERROR: $localize`Please enter a valid location`,
  LOCATION_EMPTY_ERROR: $localize`Location cannot be empty`,
};

export const SORT_OPTIONS: Items[] = [
  { id: 'D1', selected: true },
  { id: 'D3', selected: true },
  { id: 'D9', selected: true },
  { id: 'L1', selected: true },
  { id: 'P1', selected: true },
  { id: 'P4', selected: true },
  { id: 'P7', selected: true },
  { id: 'S1', selected: true },
  { id: 'S7', selected: true },
];

export const SORT_OPTION_LIST = [...SORT_OPTIONS].map((item) => {
  return {
    label: item.id,
    value: item.id,
  };
});

export interface FileUploadModel {
  trackingNumber: string;
  location?: string;
}
